import { type ReactNode, useEffect, useState } from "react";

import { useCustomNotification } from "../../hooks";

export interface OnlineStatusListenerProps {
  children?: ReactNode;
  offlineDescription: string;
  offlineMessage: string;
  onlineDescription: string;
  onlineMessage: string;
}

export const OnlineStatusListener = ({
  children,
  offlineMessage,
  offlineDescription,
  onlineMessage,
  onlineDescription,
}: OnlineStatusListenerProps) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const { showNotification } = useCustomNotification();

  useEffect(() => {
    const handleOnline = () => {
      if (!isOnline) {
        showNotification({
          type: "success",
          message: onlineMessage,
          description: onlineDescription,
        });
      }
      setIsOnline(true);
    };

    const handleOffline = () => {
      showNotification({
        type: "error",
        message: offlineMessage,
        description: offlineDescription,
      });
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [
    isOnline,
    offlineMessage,
    offlineDescription,
    onlineMessage,
    onlineDescription,
    showNotification,
  ]);

  return <>{children}</>;
};

export default OnlineStatusListener;
